import { Chip } from "@mui/material";
import React from "react";
import { BADGE_COLORS } from "../../constants";

interface BadgeProps {
  label: string;
  variant: "success" | "error" | "warning" | "info";
}

const Badge: React.FC<BadgeProps> = ({ label, variant }) => {
  const color = BADGE_COLORS[variant]?.color;

  return (
    <Chip
      label={label}
      size="small"
      variant="outlined"
      sx={{
        color: color,
        borderColor: color,
        fontSize: "11px",
        fontWeight: 500,
        height: "20px",
        "& .MuiChip-label": { px: 0.75 },
      }}
    />
  );
};

export default Badge;
